import { Component, h, ComponentInterface, Element, Host } from "@stencil/core";

/**
 * @slot (default) - the items that compose the menu
 * @slot button - the footer button to open the menu
 */
@Component({
    tag: "uic-footer-menu",
    styleUrl: "footer-menu.scss",
})
export class FooterMenu implements ComponentInterface {
    @Element()
    private host: HTMLUicFooterMenuElement;

    private handleMenuItemsSlotClick(event: Event) {
        const target = event.target as HTMLElement;
        const isValidTarget =
            !target || !target.classList.contains("uic-footer-menu__items");

        if (isValidTarget) {
            this.host.querySelector("uic-popover").open = false;
        }
    }

    private handleButtonSlotClick(event: Event) {
        //@ts-expect-error: method instance is not bound to uic-footer-menu
        // cancel click events from the wrapper to prevent interactions with popover
        if (event.target === this) {
            event.stopPropagation();
        }
    }

    private handleShow(event: any) {
        const button = event.target.querySelector(".uic-footer-menu__button");
        const items = event.target.querySelector(".uic-footer-menu__items");
        if (button && items) {
            items.style.width = `${button.clientWidth - 16}px`;
        }
    }

    render() {
        return (
            <Host class="uic-footer-menu">
                <uic-popover
                    onUicShow={(e) => this.handleShow(e)}
                    placement="top"
                    distance={0}
                    class="uic-footer-menu__popover"
                >
                    <div
                        slot="trigger"
                        class="uic-footer-menu__button"
                        onClick={this.handleButtonSlotClick}
                    >
                        <slot name="button"></slot>
                    </div>
                    <div
                        onClick={(e) => this.handleMenuItemsSlotClick(e)}
                        class="uic-footer-menu__items"
                    >
                        <slot></slot>
                    </div>
                </uic-popover>
            </Host>
        );
    }
}
